export default "__VITE_ASSET__DxbHSysh__"